



















































































import AppraisalSheet from "@/components/appraisal/AppraisalSheet.vue";
import InvoicePartySheet from "@/components/invoice/InvoicePartySheet.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PartnerModule } from "@/store/modules/partner";
import CompanyMapDialog from "@/views/company/CompanyMapDialog.vue";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ReportAppraisalCreateDialog from "./ReportAppraisalCreateDialog.vue";
import ReportAppraisalRequestDialog from "./ReportAppraisalRequestDialog.vue";

@Component({
  components: {
    MIconButton,
    MNoContent,
    CompanyMapDialog,
    ReportAppraisalRequestDialog,
    ReportAppraisalCreateDialog,
    MTextField,
    MSelect,
    InvoicePartySheet,
    LineItemsForm,
    SelectAssignees,
    AppraisalSheet
  },
  filters: {}
})
export default class PartnerReportAppraisalCard extends mixins(PermissionMixin) {
  requestDialog = false;
  createDialog = false;
  show = false;
  showDocument = false;
  activeAppraisal = 0;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get statusItems() {
    return Object.values(RequestStatusEnum).map(value => ({
      value,
      text: this.$t(`enums.RequestStatusEnum.${value}`)
    }));
  }

  removeFromReport(index: number) {
    this.report.appraisals.splice(index, 1);
  }
}
